// Normativa en dos idiomas (Ann 2026-09-10): «al darle al PDF, que pregunte qué versión
// imprimir». Viene marcado el idioma que el cliente tiene en su plataforma.
// Si solo existe una versión publicada, NO se pregunta: se imprime como siempre.
export const IDIOMAS_NORMATIVA = { es: 'Castellano', ca: 'Català' };

const langDe = (t) => String((t && t.lang) || 'es').toLowerCase();

// { es: plantilla, ca: plantilla } · solo NORMATIVA PUBLICADAS; si hay varias de un
// idioma, gana la marcada «Imprime».
export function normativasPorIdioma(templates) {
  const out = {};
  (Array.isArray(templates) ? templates : []).forEach((t) => {
    if (!t || t.type !== 'NORMATIVA' || t.status !== 'PUBLISHED') return;
    const lang = langDe(t);
    if (!IDIOMAS_NORMATIVA[lang]) return;
    if (!out[lang] || (t.is_print_default && !out[lang].is_print_default)) out[lang] = t;
  });
  return out;
}

export const hayQuePreguntarIdioma = (porIdioma) => Object.keys(porIdioma || {}).length > 1;

export function idiomaInicial(idiomaCliente, porIdioma) {
  const l = String(idiomaCliente || 'es').toLowerCase();
  if (porIdioma && porIdioma[l]) return l;
  return porIdioma && porIdioma.es ? 'es' : Object.keys(porIdioma || {})[0] || 'es';
}

// La normativa de OTRO idioma no se lista aparte: se elige al imprimir.
export const esNormativaAlternativa = (t, porIdioma) =>
  !!t && t.type === 'NORMATIVA' && langDe(t) !== 'es' && !!(porIdioma && porIdioma.es);

export const langDePlantilla = langDe;
